'use client'; // This is our interactive island

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import ProductCard from '@/features/product-card/components/productCard';
import { Product } from '../types/type'; // Assuming you have this type definition
import 'swiper/css';

interface SliderProps {
  products: Product[];
}

export const BestSellingSlider: React.FC<SliderProps> = ({ products }) => {
  return (
    <Swiper
      spaceBetween={12}
      loop={true}
      modules={[Autoplay]}
      slidesPerView={5} // Start with the desktop view
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }}
      breakpoints={{
        320: { slidesPerView: 2 },
        480: { slidesPerView: 2.25 },
        768: { slidesPerView: 3.25 },
        992: { slidesPerView: 4.25, spaceBetween: 24 },
        1200: { slidesPerView: 5 },
      }}
    >
      {products.map((product) => (
        <SwiperSlide key={product.id}>
          <div className="py-1">
            <ProductCard data={product} />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
